import { CoordinateType } from "@/types/map";
import { loadModules } from "esri-loader";
import { BD_2_GCJ, GCJ_2_WGS, GCJ_2_BD, WGS_2_GCJ } from "./tools/coordinate";
import turf_distance from "@turf/distance";
import * as turf from "@turf/helpers";

export class Utils {
  private constructor() {}
  public static async loadScripts(scriptUrls: string[]): Promise<any> {
    console.log(scriptUrls);
    let promises = scriptUrls.map((url) => {
      return new Promise((resolve, reject) => {
        const scriptElement = document.createElement("script");
        scriptElement.src = url;
        scriptElement.onload = resolve;
        document.body.appendChild(scriptElement);
      });
    });
    return new Promise((resolve) => {
      Promise.all(promises).then((e) => {
        resolve(e);
      });
    });
  }
  public static async loadCss(cssUrls: string[]): Promise<any> {
    let promises = cssUrls.map((cssUrl) => {
      return new Promise((resolve) => {
        const link = document.createElement("link");
        link.type = "text/css";
        link.rel = "stylesheet";
        link.href = cssUrl;
        link.onload = resolve;
        document.body.appendChild(link);
      });
    });

    return new Promise((resolve) => {
      Promise.all(promises).then((e) => {
        resolve(e);
      });
    });
  }
  //深度克隆
  public static copyObject(obj: object) {
    return JSON.parse(JSON.stringify(obj));
  }
  public static getZoom(
    view: __esri.MapView | __esri.SceneView,
    scale: number
  ): number {
    if (scale == 0) {
      return 0;
    }
    let zoom: number = 0;
    (view.map.allLayers.getItemAt(0) as any).tileInfo.lods.forEach(
      (lod: any) => {
        if (lod.scale == scale) {
          zoom = lod.level;
        }
      }
    );
    return zoom;
  }
  public static resetMap(view: any) {
    let mapOption = view.mapOptions.options;
    view.goTo({
      zoom: mapOption.zoom || 0,
      center: mapOption.center,
    });
  }
  public static getGeometryPoint(geometry: any) {
    if (geometry.type == "point") {
      return geometry;
    } else if (geometry.type == "polyline") {
      let len = geometry.paths[0].length;
      let index = Math.floor(len / 2);
      return geometry.getPoint(0, index);
    } else if (geometry.type == "polygon") {
      return geometry.centroid;
    }
  }
  public static getMostScale(
    view: __esri.MapView | __esri.SceneView,
    maxScale: number,
    minSacle: number
  ) {
    let most: number = 0;
    if (maxScale == 0 && minSacle == 0) {
      return 0;
    }
    let last: number = 0;
    let layer: any = view.map.allLayers.getItemAt(0);
    if (layer.tileInfo && layer.tileInfo.lods) {
      let lods = (view.map.allLayers.getItemAt(0) as any).tileInfo.lods;
      for (let i = 0; i < lods.length; i++) {
        let lod = lods[i];
        if (maxScale != 0) {
          if (lod.scale < maxScale) {
            most = last;
            break;
          }
        } else if (minSacle != 0 && lod.scale < minSacle) {
          most = lod.scale;
          break;
        }
        last = lod.scale;
      }
    }

    console.log(most);
    return most;
  }
  public static getScale(
    view: __esri.MapView | __esri.SceneView,
    zoom: number
  ): number {
    let scale: number = 0;
    if (zoom == 0) {
      return 0;
    }
    let layer: any = view.map.allLayers.getItemAt(0);
    if (layer.tileInfo && layer.tileInfo.lods) {
      (view.map.allLayers.getItemAt(0) as any).tileInfo.lods.forEach(
        (lod: any) => {
          if (lod.level == zoom) {
            scale = lod.scale;
          }
        }
      );
    }
    return scale;
  }
  public static getContent(attr: any, content: string) {
    let tipContent = content;
    if (content) {
      //键值对
      for (let fieldName in attr) {
        if (attr.hasOwnProperty(fieldName)) {
          tipContent = tipContent.replace(
            "{" + fieldName + "}",
            attr[fieldName]
          );
        }
      }
    }
    return tipContent;
  }
  public static getCharNumber(letter: string) {
    let index = letter.toLowerCase().charCodeAt(0) - 96;
    return index.toString();
  }
  public static getCharLetter(number: number | string) {
    let str = String.fromCharCode(Number(number) + 96).toUpperCase();
    return str;
  }
  public static async getPostion(geometry: any) {
    const [geometryJsonUtils] = await loadModules([
      "esri/geometry/support/jsonUtils",
    ]);
    let center = geometry;
    if (geometry.type == "point") {
    } else if (geometry.type == "polyline") {
      center = geometry.extent.center;
    } else if (geometry.type == "extent") {
      center = geometry.center;
    } else if (geometry.type == "polygon" || geometry.type == "circle") {
      center = geometry.centroid;
    } else {
      center = geometryJsonUtils.fromJSON(geometry);
    }
    return center;
  }

  //将symbol转为json格式
  public static getSymbolJson(type: string, symbol: any): any {
    let symJson;
    if (type == "polyline") {
      symJson = {
        type: symbol.type,
        color: symbol.color,
        width: symbol.width,
      };
    } else if (type == "polygon") {
      symJson = {
        type: symbol.type,
        color: symbol.color
          ? [symbol.color.r, symbol.color.g, symbol.color.b, symbol.color.a]
          : [23, 145, 252, 0.4],
        outline: {
          type: symbol.outline.type,
          style: symbol.outline.style,
          color: symbol.outline.color
            ? [
                symbol.outline.color.r,
                symbol.outline.color.g,
                symbol.outline.color.b,
                symbol.outline.color.a,
              ]
            : [23, 145, 252, 0.4],
          width: symbol.outline.width,
        },
      };
    } else {
      //point
      symJson = {
        type: "point",
        url: symbol.url,
        width: symbol.width,
        height: symbol.height,
        xoffset: symbol.xoffset || 0,
        yoffset: symbol.yoffset || 0,
      };
    }
    return symJson;
  }
  public static getGraphicObject(graphics: any[]): any[] {
    let overlays: any[] = [];
    graphics.forEach((graphic: any, index: number) => {
      if (graphic.isCluster === true) {
        //如果是聚合点位.
        overlays.push(graphic);
      } else {
        let symbol = graphic.symbol as any;
        if (graphic.geometry && graphic.geometry.type == "polyline") {
          symbol = {
            type: symbol.type,
            color: symbol.color,
            width: symbol.width,
          };
        } else if (graphic.geometry && graphic.geometry.type == "polygon") {
          symbol = {
            type: symbol.type,
            color: symbol.color
              ? [symbol.color.r, symbol.color.g, symbol.color.b, symbol.color.a]
              : [23, 145, 252, 0.4],
            outline: {
              type: symbol.outline.type,
              style: symbol.outline.style,
              color: symbol.outline.color
                ? [
                    symbol.outline.color.r,
                    symbol.outline.color.g,
                    symbol.outline.color.b,
                    symbol.outline.color.a,
                  ]
                : [23, 145, 252, 0.4],
              width: symbol.outline.width,
            },
          };
        } else if (graphic.geometry && graphic.geometry.type == "point") {
          //point
          symbol = {
            type: "point",
            url: symbol.url,
            width: symbol.width,
            height: symbol.height,
            xoffset: symbol.xoffset || 0,
            yoffset: symbol.yoffset || 0,
          };
        } else {
          symbol = {};
        }
        overlays.push({
          geometry: graphic.geometry || {
            geometry: { x: graphic.x, y: graphic.y },
          },
          fields: {
            id: graphic.attributes.id || "drawoverlay" + index.toString(),
            type: graphic.attributes.type || "drawOverlays",
            ...graphic.attributes,
          },
          id: graphic.attributes.id,
          symbol: symbol,
        });
      }
    });
    return overlays;
  }
  public async sleep(interval: number): Promise<void> {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve();
      }, interval * 1000);
    });
  }

  // 计算两点之间距离
  public static distance(p1: [number, number], p2: [number, number]): number {
    let from = turf.point(p1);
    let to = turf.point(p2);
    let d = turf_distance(from, to, { units: "kilometers" }) * 1000;
    return d;
  }
}

//提供坐标转换的功能
export function TransformCoordinates(
  origin: any,
  target: any,
  coordinates: number[],
  result?: any
): any {
  if (origin == CoordinateType.BD09 && target == CoordinateType.GCJ02) {
    //百度转火星
    const res = BD_2_GCJ({ lng: coordinates[0], lat: coordinates[1] });
    result = [res.lng, res.lat];
    return result;
  } else if (origin == CoordinateType.BD09 && target == CoordinateType.WGS84) {
    //百度转wgs84
    //转火星再转wgs84
    const res0 = BD_2_GCJ({ lng: coordinates[0], lat: coordinates[1] });
    const res = GCJ_2_WGS(res0);
    result = [res.lng, res.lat];
    return result;
  } else if (origin == CoordinateType.GCJ02 && target == CoordinateType.BD09) {
    //火星转百度
    const res = GCJ_2_BD({ lng: coordinates[0], lat: coordinates[1] });
    result = [res.lng, res.lat];
    return result;
  } else if (origin == CoordinateType.GCJ02 && target == CoordinateType.WGS84) {
    //火星转wgs84
    const res = GCJ_2_WGS({ lng: coordinates[0], lat: coordinates[1] });
    result = [res.lng, res.lat];
    return result;
  } else if (origin == CoordinateType.WGS84 && target == CoordinateType.BD09) {
    //wgs84转百度
    //转火星再转百度
    const res0 = WGS_2_GCJ({ lng: coordinates[0], lat: coordinates[1] });
    const res = GCJ_2_BD(res0);
    result = [res.lng, res.lat];
    return result;
  } else if (origin == CoordinateType.WGS84 && target == CoordinateType.GCJ02) {
    //wgs84转火星
    const res = WGS_2_GCJ({ lng: coordinates[0], lat: coordinates[1] });
    result = [res.lng, res.lat];
    return result;
  }
}
